import React from 'react'
import HistoricStatusView from './HistoricStatusView/HistoricStatusView'
import { TimelineItem } from '../../../../../components/molecules/Timeline/Timeline'
import { useSingleSpendingDemand} from '../../../hooks'

import { SpendingDemandHistoricStatus } from '../../../types/spendingDemandHistoricStatut.types'
import { dateConverter } from '../../../../../utils/dateConverter'
import { useQuery } from '@tanstack/react-query'
import teamAPI from '../../../../team/services/teamAPI'
import { CoinIcon, StopSquareIcon } from '../../../../../assets/JWayIcons'
import useUserAuth from '../../../../auth/hook/useUserAuth'
import { IUser } from '../../../../auth/types/user.types'



export default function HistoricStatusPresenter() {




const {historicStatus, singleSpendingDemandData: singleSpending, isLoading,managerWaitingValidation } =  useSingleSpendingDemand()
const userName = singleSpending?.spending_demand_user?.username
const userLastName = singleSpending?.spending_demand_user?.lastname

const listManagerWaitingValisation = managerWaitingValidation.data
if(historicStatus.isPending || isLoading){
  return <span>Chargement...</span>
}

if(historicStatus.isError){
  return <span>Erreur de chargement</span>
}

if(!historicStatus.data){
  return <span>Pas de données</span>
}

const listPoint : TimelineItem[]= [

]

const getDateString = (status:  SpendingDemandHistoricStatus)=> {
  return dateConverter(status.spending_demand_sh_created_at)
}

if((singleSpending?.spending_demand_status === 'WAITING_VALIDATION')

  || (singleSpending?.spending_demand_status === 'WAITING_VALIDATION_ADMIN')
  || (singleSpending?.spending_demand_status === 'WAITING_VALIDATION_MANAGER')
){
  listPoint.push({
    title: 'Validation en attente',
    description: () =>{ 
      
      if (singleSpending?.spending_demand_last_team_from && singleSpending?.spending_demand_comptable_team === "") {
        return (<>En attente d'une validation  de <ListManagerWaitingValidationRenderer teamId={singleSpending?.spending_demand_last_team_from}/> </>)
      }
      
      if (singleSpending?.spending_demand_comptable_team) {
        return (<>En attente d'une validation  de <ListMemberWaitingValidationRenderer teamId={singleSpending?.spending_demand_comptable_team}/> </>)
      }
      return (<>En attente d'une validation  de {" "}
     {listManagerWaitingValisation.map((manager) => manager?.username+' '+manager?.lastname).join(', ')}</>) 
     },
    iconType: 'valid',
    isDone: false,
  })
}

if(historicStatus.data?.data && historicStatus.data.data.length  > 0){

  const dataSorted = historicStatus.data.data.sort((a: SpendingDemandHistoricStatus, b: SpendingDemandHistoricStatus) => {
    return  new Date(b.spending_demand_sh_created_at).getTime() - new Date(a.spending_demand_sh_created_at).getTime()
  })


  dataSorted.forEach((status: SpendingDemandHistoricStatus) => {

    if(status?.spending_demand_sh_status === 'REFUSED'){
      listPoint.push({
        title: 'Refusée',
        description: () => (<>Par <ActionAuthor user={status?.spending_demand_sh_user}/> le {getDateString(status)}</>),
        iconType: 'cross',
        color: '#CE8585',
        isDone: true,
        subDescription:( (status?.spending_demand_sh_remak && status?.spending_demand_sh_remak !== "") ?''+status?.spending_demand_sh_remak : undefined)
      })
    }

    if(status?.spending_demand_sh_status === 'WAITING_UPDATE'){
      listPoint.push({
        title: 'Demande de correction',
        description: () => (<>Par <ActionAuthor user={status?.spending_demand_sh_user}/> le {getDateString(status)}</>),
        iconType: 'warning',
        color: '#e8ad61',
        isDone: true,
        subDescription:( (status?.spending_demand_sh_remak && status?.spending_demand_sh_remak !== "") ?''+status?.spending_demand_sh_remak : undefined)
      })
    }


      if (status?.spending_demand_sh_status === 'WAITING_VALIDATION' && status.spending_demand_sh_user?.user_id !== singleSpending?.spending_demand_user?.user_id) {
        
        listPoint.push({
          title: 'Validée',
          description: () => (<>Par <ActionAuthor user={status?.spending_demand_sh_user}/> le {getDateString(status)}</>),
          iconType: 'valid',
          color: '#A6C185',
          isDone: true,
          subDescription:( (status?.spending_demand_sh_remak && status?.spending_demand_sh_remak !== "") ?''+status?.spending_demand_sh_remak : undefined)
        })

      }  else  if(status?.spending_demand_sh_status === 'WAITING_VALIDATION'){
        listPoint.push({
          title: 'Modification apportée',
          description: () => (<>Par <ActionAuthor user={status?.spending_demand_sh_user}/> le {getDateString(status)}</>),
          iconType: 'pen',
          color: '#e6880d',
          isDone: true,
         // subDescription:( (status?.spending_demand_sh_remak && status?.spending_demand_sh_remak !== "") ?''+status?.spending_demand_sh_remak : undefined)
        })
      }

      

      if (status?.spending_demand_sh_status === 'VALIDATE') {
        listPoint.push({
          title: 'Validée',
          description: () => (<>Par <ActionAuthor user={status?.spending_demand_sh_user}/> le {getDateString(status)}</>),
          iconType: 'valid',
          color: '#A6C185',
          subDescription:( (status?.spending_demand_sh_remak && status?.spending_demand_sh_remak !== "") ?''+status?.spending_demand_sh_remak : undefined),
          isDone: true
        })

      }
      
      if (status?.spending_demand_sh_status === 'CANCELLED') {
        listPoint.push({
          title: 'Annulée',
          description: () => (<>Par <ActionAuthor user={status?.spending_demand_sh_user}/> le {getDateString(status)}</>),
          iconType: 'cross',
          color: '#888888',
          subDescription:( (status?.spending_demand_sh_remak && status?.spending_demand_sh_remak !== "") ?''+status?.spending_demand_sh_remak : undefined),
          isDone: true
        })

      }

      if (status?.spending_demand_sh_status === 'PAYED') {
        listPoint.push({
          title: 'Payée',
          description: () => (<>Par <ActionAuthor user={status?.spending_demand_sh_user}/> le {getDateString(status)}</>),
          iconType: 'valid',
          color: '#6b6b6b',
          subDescription:( (status?.spending_demand_sh_remak && status?.spending_demand_sh_remak !== "") ?''+status?.spending_demand_sh_remak : undefined),
          isDone: true
        })

      }

      if (status?.spending_demand_sh_status === 'CLOSED') {
        listPoint.push({
          title: 'Cloturée',
          description: () => (<>Par <ActionAuthor user={status?.spending_demand_sh_user}/> le {getDateString(status)}</>),
          IconRender: () => <StopSquareIcon size={14} color="#000000"/>,
          color: '#6b6b6b',
          subDescription:( (status?.spending_demand_sh_remak && status?.spending_demand_sh_remak !== "") ?''+status?.spending_demand_sh_remak : undefined),
          isDone: true
        })

      }

      if (status?.spending_demand_sh_status === 'CREDITED') {
        listPoint.push({
          title: 'Nouvelle avance',
          description: () => (<>Par <ActionAuthor user={status?.spending_demand_sh_user}/> le {getDateString(status)}</>),
          IconRender: () => <CoinIcon size={14} color="#000000"/>,
          color: '#64B5F6',
          subDescription:( (status?.spending_demand_sh_remak && status?.spending_demand_sh_remak !== "") ?''+status?.spending_demand_sh_remak : undefined),
          isDone: true
        })

      }

      if (status?.spending_demand_sh_status === 'NEW_SPENDING') {
        listPoint.push({
          title: 'Nouvelle dépense',
          description: () => (<>Par <ActionAuthor user={status?.spending_demand_sh_user}/> le {getDateString(status)}</>),
          iconType: 'start',
          color: '#CD853F',
          subDescription:( (status?.spending_demand_sh_remak && status?.spending_demand_sh_remak !== "") ?''+status?.spending_demand_sh_remak : undefined),
          isDone: true
        })

      }
    
      

  })


}



listPoint.push( {
  title: 'Créée',
  description: 'Par '+userName+' '+userLastName,
  iconType: 'start',
  color: '#A6C185',
  isDone: true
})

  return (
    <HistoricStatusView  items={listPoint}/>
  )
}


function ActionAuthor ({user}: {user: IUser | null}){
  const {userInfo} = useUserAuth()
  return userInfo?.user_id === user?.user_id ? <>vous</> : <>{user?.username} {user?.lastname}</>
}

const ListManagerWaitingValidationRenderer = ({teamId}: {teamId?: string}) => {
  const {userInfo} = useUserAuth()
  const {data,isLoading,isError} = useQuery({
    queryKey: ['manager-waiting-validation', teamId],
    queryFn: () => teamAPI.fetchManagerListOfTeamProtected(teamId || 'none')
  })
  if(isLoading){
    return <>...</>
  }
  if(isError){
    return <>-</>
  }
  if(!data){
    return <>-</>
  }
  return <>
  {data?.data?.data?.map((manager, index, array) => (
    
    <React.Fragment key={manager.user_id || index}>
    {userInfo?.user_id === manager.user_id ? 'vous': <>{manager.username} {manager.lastname}</>} {index < array.length - 1 ? (
      index < array.length - 2 ? 'ou ' : ' ou '
    ) : ''}
    </React.Fragment>
  ))}
  </>
}

const ListMemberWaitingValidationRenderer = ({teamId}: {teamId?: string}) => {
  const {userInfo} = useUserAuth()
  const {data,isLoading,isError} = useQuery({
    queryKey: ['member-waiting-validation', teamId],
    queryFn: () => teamAPI.fetchMembersListOfTeamProtected(teamId || 'none')
  })
  if(isLoading){
    return <>...</>
  }
  if(isError){
    return <>-</>
  }
  if(!data){
    return <>-</>
  }
  return <>
  {data?.data?.data?.map((member, index, array) => (
    <React.Fragment key={member.user_id || index}>
      {userInfo?.user_id === member.user_id ? 'vous': <>{member.username} {member.lastname}</>} {index < array.length - 1 ? (
        index < array.length - 2 ? 'ou ' : ' ou '
      ) : ''}
    </React.Fragment>
  ))}
  </>
}